

varying vec2 vUv;
varying float vCameraDistance;
uniform float uTime;

// Simple noise function (much lighter than Simplex)
float hash(float n) {
    return fract(sin(n) * 43758.5453);
}

float noise(float x) {
    float i = floor(x);
    float f = fract(x);
    f = f * f * (3.0 - 2.0 * f);
    return mix(hash(i), hash(i + 1.0), f);
}

void main() {
    vUv = uv;
    
    vec3 pos = position;
    
    float n = noise(pos.x * 0.008 + uTime);
    pos.z += n * 20.0;
    
    vec4 mvPosition = modelViewMatrix * vec4(pos, 1.0);
    gl_Position = projectionMatrix * mvPosition;
    vCameraDistance = -mvPosition.z;
}
